import { NgFor, NgIf } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-search-dropdown',
  standalone: true,
  imports: [NgFor, NgIf],
  templateUrl: './search-dropdown.component.html',
  styleUrls: ['./search-dropdown.component.scss']
})
export class SearchDropdownComponent implements OnChanges {
  /** Options from parent component */
  @Input() options: string[] = [];

  /** Emits selected search option and search text to parent */
  @Output() searchChange = new EventEmitter<{ option: string; keyword: string }>();

  searchPlaceholder = '';
  isSearchDropdownOpen = false;
  selectedOption = '';
  searchText = '';
  private debounceTimer: any;
  private validationTimer: any;
  isClear = false;

  /** Update placeholder when options change */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['options'] && this.options?.length > 0) {
      this.selectedOption = this.options[0];
      this.searchPlaceholder = this.selectedOption;
    }
  }

  /** Toggle dropdown open/close */
  openSearchDropdown(): void {
    this.isSearchDropdownOpen = !this.isSearchDropdownOpen;
  }

  /** Handle text input change */
  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchText = input.value.trim();
    if (this.validationTimer) {
      clearTimeout(this.validationTimer);
    }
    this.validationTimer = setTimeout(() => {
      if (this.searchText.length > 0 && this.searchText.length < 3 && !this.searchText.includes('@')) {
        Helpers.smallAlertBox("ERROR", 'Enter at least 3 characters', "ERROR", 5000);
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (this.searchText.includes('@') && !emailRegex.test(this.searchText)) {
        Helpers.smallAlertBox("ERROR", 'Enter a complete email address (e.g. name@company.com) or remove @ to search by username.', "ERROR", 5000);
      }
    }, 2000)
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    if (!this.searchText) {
      this.debounceTimer = setTimeout(() => {
        if(!this.isClear) return;
        this.isClear = false;
        this.emitSearchChange();
      }, 2000);
    }
  }

  /** Handle dropdown selection */
  selectedSearchOption(option: string): void {
    this.selectedOption = option;
    this.searchPlaceholder = option;
    this.isSearchDropdownOpen = false;
    this.emitSearchChange();
  }

  /** Emit combined search info to parent */
  private emitSearchChange(): void {
    this.searchChange.emit({
      option: this.selectedOption,
      keyword: this.searchText
    });
  }

  /** Close dropdown on outside click */
  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.searchBar-container')) {
      this.isSearchDropdownOpen = false;
    }
  }

  clearSearch(emit = true) {
    this.searchText = '';
    if (emit && this.isClear) {
      this.isClear = false;
      this.emitSearchChange();
    }
  }

  isValidSearch(): boolean {
    const text = this.searchText.trim();
    if (!text) return false;
    if (text.includes('@')) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(text);
    } else {
      return text.length >= 3;
    }
  }

  onSearchClick(): void {
    if (!this.isValidSearch()) return;
    this.isClear = true;
    this.emitSearchChange();
  }
}